/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityDataleaksInnerData
 */
export interface ControlEntityDataleaksInnerData {
    /**
     * 
     * @type {string}
     * @memberof ControlEntityDataleaksInnerData
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityDataleaksInnerData
     */
    count?: number;
}

/**
 * Check if a given object implements the ControlEntityDataleaksInnerData interface.
 */
export function instanceOfControlEntityDataleaksInnerData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityDataleaksInnerDataFromJSON(json: any): ControlEntityDataleaksInnerData {
    return ControlEntityDataleaksInnerDataFromJSONTyped(json, false);
}

export function ControlEntityDataleaksInnerDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityDataleaksInnerData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function ControlEntityDataleaksInnerDataToJSON(value?: ControlEntityDataleaksInnerData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'count': value.count,
    };
}

